import './input.css';

const Component = props => (
  <input className='input-text' {...props} />
)

export default Component;
